/* eslint-disable arrow-body-style */
import { useContext, useState } from 'react';
import { useParams } from 'umi';
// import studioDefault from '@/pages/dashboard/assets/images/benchmark/studio_default.png';
import { getApiData } from '@/pages/benchmark/services/common';
import { StudioContext } from '@home/pages/studio/context';
import { IStudioInfo } from '@home/pages/studio/type';

const fixData = (data: any, company: { name: string; img_url: string; }, studio_code: string) => {
  const { name, img_url } = company;
  return data.map((item: any) => {
    const { icon, version, studio } = item || {};

    // 判断是否为本品，由于后端本品不给icon数据，需前端做判断拿
    const isStudio = studio?.toLowerCase().trim() === studio_code?.toLowerCase().trim();
    const cover = isStudio ? img_url : icon;
    const studioName = isStudio ? name : studio;

    // 为所有非标题行对象设置一个默认的 groupIndex
    const groupIndex = item?.isTitleRow ? item?.groupIndex : isStudio ? 1 : 2;

    return {
      ...(item || {}),
      value: `${studioName} - ${version}`,
      cover,
      icon: cover,
      isStudio,
      combined_id: '',
      console_id: '',
      game_genre: '',
      game_genre_cn: '',
      game_id: `${studioName} - ${version}`,
      game_name: studioName,
      mobile_id: '',
      pc_id: '',
      publisher: '',
      publisher_country: '',
      release_time: '',
      text: `${studioName} - ${version}`,
      groupIndex // 用于搜索控制对应分组显示
    };
  });
};

const formatCompetitorList = (
  data: { icon: string; version: string; studio: string; }[],
  company: { name: string; img_url: string; },
  studio_code: string,
  setCompetitorsDefault: (competitorsDefault: any[]) => void,
  setHasCompetitorsData: (hasData: boolean) => void,
) => {
  // 本品和竞品数据
  const studioData = data?.filter(
    (item: any) => studio_code === item?.studio,
  );
  const noStudioData = data?.filter(
    (item: any) => studio_code !== item?.studio,
  );

  // 设置是否有竞品数据
  setHasCompetitorsData(noStudioData?.length > 0);

  // 设置第一笔为默认值，过滤掉undefined
  const defaultCompetitors = [studioData[0], noStudioData[0]].filter(Boolean);
  setCompetitorsDefault(fixData(defaultCompetitors, company, studio_code));

  // 设置select列表数据
  return fixData(
    [
      {
        title: 'Studio',
        groupIndex: 1,
        isTitleRow: true,
      },
      ...studioData,
      ...(noStudioData.length > 0
        ? [
          {
            title: 'benchmark_table_competitors',
            groupIndex: 2,
            isTitleRow: true,
          }
        ]
        : []),
      ...noStudioData,
    ],
    company,
    studio_code,
  );
};

export const useFilterData = () => {
  const [selectorList, setSelectorList] = useState<{ [key: string]: any[]; }>({
    competitor: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { studioId: studioCode } = useParams() || ({} as any);
  const {
    studioInfo: { company },
    currentGame: { studio_code },
  } = useContext<IStudioInfo>(StudioContext);

  const [competitorsDefault, setCompetitorsDefault] = useState<any[]>([]);
  const [hasCompetitors, setHasCompetitors] = useState(true);

  const fetchCompetitorList = async (
    setCompetorLoading,
    setGameList,
    setCompetitorError,
  ) => {
    setLoading(true);
    setCompetorLoading(true);
    const reqParms = {
      studio_code: studioCode,
    };
    try {
      const data = await getApiData(
        '/api/v2/dashboard/studio/assessment/select',
        reqParms,
      );
      setSelectorList(data?.studio_version_list || []);
      const result = formatCompetitorList(
        data?.studio_version_list || [],
        company,
        studio_code,
        setCompetitorsDefault,
        setHasCompetitors,
      );
      setGameList(result);

      setError(false);
      setCompetitorError(false);
    } catch (error) {
      console.error('Failed to fetch game list:', error);
      setError(true);
      setCompetitorError(true);
    } finally {
      setCompetorLoading(false);
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    selector: selectorList,
    competitorsDefault,
    getData: fetchCompetitorList,
    studioCode,
    hasCompetitors,
  };
};
